import { CheckableFieldComponent } from "./chunk-UIONNZDK.js";
import { Radio_default } from "./chunk-6Y4MXSCS.js";
import { Icon_default } from "./chunk-HALE5GZ6.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioField/RadioField.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var RadioField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      label,
      description,
      badge,
      secondaryAction,
      variant,
      validation,
      validationMessage,
      suffix,
      icon,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "description", "badge", "secondaryAction", "variant", "validation", "validationMessage", "suffix", "icon", "className"]);
  return /* @__PURE__ */jsxs(CheckableFieldComponent, {
    id,
    name,
    label,
    description,
    badge,
    secondaryAction,
    variant: variant === "multiline" ? "primary" : variant,
    validation,
    validationMessage,
    className: clsx("pd:radio-field", variant === "multiline" && "pd:radio-field--multiline", className),
    children: [/* @__PURE__ */jsx(CheckableFieldComponent.Input, __spreadValues({
      ref,
      as: Radio_default,
      className: "pd:radio-field__input"
    }, rest)), /* @__PURE__ */jsx(CheckableFieldComponent.Wrap, {
      className: "pd:radio-field__wrap",
      children: variant === "multiline" ? /* @__PURE__ */jsxs(Fragment, {
        children: [/* @__PURE__ */jsxs("div", {
          className: "pd:flex pd:flex-wrap pd:gap-2",
          children: [/* @__PURE__ */jsx(CheckableFieldComponent.Label, {
            className: "pd:radio-field__label"
          }), /* @__PURE__ */jsx(CheckableFieldComponent.SecondaryAction, {
            className: "pd:radio-field__secondary-action"
          }), /* @__PURE__ */jsx(CheckableFieldComponent.Badge, {
            className: "pd:radio-field__badge"
          }), /* @__PURE__ */jsx(CheckableFieldComponent.Validation, {
            className: "pd:radio-field__validation"
          }), /* @__PURE__ */jsx(CheckableFieldComponent.Description, {
            className: "pd:radio-field__description"
          })]
        }), icon && /* @__PURE__ */jsx(Icon_default, {
          icon,
          size: "xl"
        })]
      }) : /* @__PURE__ */jsxs(Fragment, {
        children: [/* @__PURE__ */jsx(CheckableFieldComponent.Label, {
          className: "pd:radio-field__label"
        }), /* @__PURE__ */jsx(CheckableFieldComponent.Description, {
          className: "pd:radio-field__description"
        }), /* @__PURE__ */jsx(CheckableFieldComponent.SecondaryAction, {
          className: "pd:radio-field__secondary-action"
        }), /* @__PURE__ */jsx(CheckableFieldComponent.Badge, {
          className: "pd:radio-field__badge"
        }), /* @__PURE__ */jsx(CheckableFieldComponent.Validation, {
          className: "pd:radio-field__validation"
        }), suffix && /* @__PURE__ */jsx("span", {
          className: "pd:ml-auto",
          children: suffix
        })]
      })
    })]
  });
});
var RadioField_default = RadioField;
export { RadioField_default };